import { useWindowWidth } from "materia"
import { DiplomaWidgetMobileSkeleton } from "../DiplomaWidgetMobile"
import { EventWidgetMobileSkeleton } from "../EventWidgetMobile"
import { NewsWidgetMobileSkeleton } from "../NewsWidgetMobile"
import { RecentActivityWidgetMobileSkeleton } from "../RecentActivityWidgetMobile"
import s from "./MobileWidgets.module.scss"

export const MobileWidgetsSkeleton = () => {
  const { isBigWindow } = useWindowWidth()
  if (isBigWindow) return

  return (
    <div className={s.skeleton}>
      <DiplomaWidgetMobileSkeleton />
      <EventWidgetMobileSkeleton />
      <NewsWidgetMobileSkeleton />
      <RecentActivityWidgetMobileSkeleton />
    </div>
  )
}
